import React from 'react';

import { ExplorerStyles } from '~src/spacesPlatform/components/Explorer/ExplorerStyles';
import { ExplorerToolbarTestIds } from '~src/spacesPlatform/components/Explorer/ExplorerToolbar';
import { ExplorerDropdown } from '~src/spacesPlatform/components/Explorer/widgets/ExplorerDropdown';
import { ExplorerFlyoutPanelProps } from '~src/spacesPlatform/components/Explorer/widgets/ExplorerFlyoutPanel';

import { Messages } from '../../../codegen/Localize';
import { DatasourceDefinition } from '../../../datasource/components/contentDefinitions/DatasourceDefinition';
import { getExplorableItemDefinition} from '../../../spacesPlatform/contentDefinitionInterfaces/ContentDefinitionsLists';
import { MixedContentItemDefinition } from '../../../spacesPlatform/contentDefinitionInterfaces/ContentDefinitionsTypes';
import { SITE_SPACE_CONTENT_RELAY_PLAN, SITE_SPACE_EXPLORE, SiteSpaceContentType } from '../../../spacesPlatform/state/SiteSpaceContentTypeState';
import { ConnectedSiteLevelFilterMenu } from './ConnectedSiteLevelFilterMenu';

export interface SiteLevelFilterByTypeDropdownProps {
  readonly changeCurrentContentType: (selectedContentType: SiteSpaceContentType) => void;
  readonly currentContentType: SiteSpaceContentType;
}

export class SiteLevelFilterByTypeDropdown extends React.PureComponent<SiteLevelFilterByTypeDropdownProps> {
  public render(): JSX.Element {
    return (
      <ExplorerDropdown
        testId={SiteLevelFilterByTypeDropdownTestIds.dropdown}
        renderButtonContent={this.renderButtonContent}
        renderPanel={this.renderPanel}
        panelTitle={Messages.siteFilterByTypeDropdown_PanelTitle()}
      />
    );
  }

  private renderPanel = (props: ExplorerFlyoutPanelProps): JSX.Element => {
    return (
      <ConnectedSiteLevelFilterMenu
        onSelect={(value: SiteSpaceContentType) => {
          props.onCloseRequest();
          this.handleSelection(value);
        }}
        anchorEl={props.anchorEl}
        testId={props.testId}
        onCloseRequest={props.onCloseRequest}
        id={`${props.testId}-${ExplorerToolbarTestIds.ExplorerDropdownLabelSuffix}`}
        role={'menu'}
      />
    );
  };

  private renderButtonContent = (): JSX.Element => {
    return <span className={ExplorerStyles.SiteSpaceContentFilterButton}>{this.getButtonText()}</span>;
  };

  private getButtonText = (): string => {
    if (this.props.currentContentType === 'dataconnection') {
      return DatasourceDefinition.siteFilterByTypeDropdownName();
    } else if (this.props.currentContentType === SITE_SPACE_EXPLORE) {
      return Messages.siteFilterByTypeDropdown_TopLevelProjects();
    } else if (this.props.currentContentType === SITE_SPACE_CONTENT_RELAY_PLAN) {
      return Messages.siteFilterByTypeDropdown_ContentRelayPlans();
    } else {
      return (getExplorableItemDefinition(this.props.currentContentType) as MixedContentItemDefinition).siteFilterByTypeDropdownName();
    }
  };

  private handleSelection = (value: SiteSpaceContentType) => {
    this.props.changeCurrentContentType(value);
  };
}

export namespace SiteLevelFilterByTypeDropdownTestIds {
  export const dropdown = 'site-filter-by';
  export const item = 'site-filter-by';
}
